import { type PlayerSettings, PlayerSettingsResponseSchema } from '@shefira/shared';

import { call } from './account.js';

/**
 * The account's settings endpoints (ADR 0029). Either token kind will do;
 * the game holds the character's.
 */

/** The settings saved on the account, or null when it never saved any. */
export async function fetchSettings(token: string): Promise<PlayerSettings | null> {
  const response = await call('/account/settings', PlayerSettingsResponseSchema, {
    method: 'GET',
    token,
  });
  return response.settings;
}

export async function pushSettings(token: string, settings: PlayerSettings): Promise<void> {
  await call('/account/settings', PlayerSettingsResponseSchema, {
    method: 'PUT',
    token,
    body: settings,
  });
}
